export default [
  {
    title: 'گزارشات',
    icon: 'ActivityIcon',
    children: [
      {
        title: 'نامه ها',
        icon: 'InboxIcon',
        route: 'Report_Tickets',
        permission: 'reports.tickets',
      },
      {
        title: 'وظایف',
        icon: 'TrelloIcon',
        route: 'Report_Tasks',
        permission: 'reports.tasks',
      },
      {
        title: 'درخواست ها',
        icon: 'SendIcon',
        route: 'Report_Requests',
        permission: 'reports.requests',
      },
      {
        title: 'صورتجلسات',
        icon: 'FileIcon',
        route: 'Report_Agendas',
        permission: 'reports.agendas',
      },
    ],
  },
]
